const formerFee = [{
  path: 'formerFee/index',
  component: resolve => require(['../../../../components/pages/user/formerFee'], resolve)
}, {
  path: 'formerFee/onlinePayment/:itemId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/formerFee/FormerFeeOnlinePayment'], resolve)
}, {
  path: 'formerFee/onlineStubPayment/:refId/:itemId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/formerFee/FormerFeeOnlineStubPayment'], resolve)
}, {
  path: 'formerFee/paymentOrder/:orderId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/formerFee/FormerFeePaymentOrder'], resolve)
}, {
  path: 'formerFee/orderSuccess/:orderId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/formerFee/FormerFeeOrderSuccess'], resolve)
}, {
  path: 'formerFee/paymentRecord',
  component: resolve => require(['../../../../components/pages/user/formerFee/FormerFeePaymentRecord'], resolve)
}]

export default formerFee



// WEBPACK FOOTER //
// ./src/router/pages/user/formerFee/index.js